import { all } from 'redux-saga/effects';
import loginSaga from './auth/loginSaga';
import organizationSaga from './organizations/organizationSaga';
import partnerSaga from './partners/partnerSaga';
import planSaga from './plans/planSaga';
import subscriptionSaga from './subscriptions/subscriptionSaga';
import invoicesSaga from './invoices/invoicesSaga';

export default function* rootSaga() {
  yield all([loginSaga(), organizationSaga(), partnerSaga(), planSaga(), subscriptionSaga(), invoicesSaga()]);
}
